const light = {
  '--text': 'var(--foreground)',
  '--background': 'var(--base-1)',
  '--background-hover': 'var(--base-2)',
  '--background-active': 'var(--base-3)',
  '--text-selected': 'var(--accent-9)',
  '--background-selected': 'var(--accent-2)'
}

export const colorSchemes = {
  light
}
